const RenderIf = ({cond = false, children, falsyElement = <></>}) => {
    return cond ? children : falsyElement;
};

export default RenderIf;
